<template>
    <b-navbar type="dark" class="mobile-sub-header">
        <search-nav-item />
    </b-navbar>
</template>

<script>
import SearchNavItem from './common/SearchNavItem'

export default {
    name: 'MobileSubHeader',
    components: { SearchNavItem }
}
</script>

<style lang="scss" scoped>
.mobile-sub-header {
    @media screen and #{$new-break3close} {
        height: var(--sub-header-height);
        width: 100%;
    }
}
</style>
